import { createElement } from 'react';

const SvgGooglePlay = (props) => (createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 15 16", fill: "none" }, props),
    createElement("path", { d: "M10.498 5.714h0l3.05 1.725h.001c.364.207.451.422.451.55 0 .127-.086.339-.449.541h0l-.002.001-3.051 1.729h0-.003l-.056.033-.001.001-9.047 5.154c-.413.227-.66.16-.78.057l-.024-.024a.843.843 0 01-.185-.587V1.102A.852.852 0 01.585.524L.61.5c.118-.107.364-.18.78.054 0 0 0 0 0 0l9.108 5.159z", stroke: "currentColor", strokeWidth: 0.8 })));

export default SvgGooglePlay;
